// source: PublicAggreDealsV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.PublicAggreDealsV3Api', null, global);
goog.exportSymbol('proto.PublicAggreDealsV3ApiItem', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicAggreDealsV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.PublicAggreDealsV3Api.repeatedFields_, null);
};
goog.inherits(proto.PublicAggreDealsV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicAggreDealsV3Api.displayName = 'proto.PublicAggreDealsV3Api';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicAggreDealsV3ApiItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PublicAggreDealsV3ApiItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicAggreDealsV3ApiItem.displayName = 'proto.PublicAggreDealsV3ApiItem';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.PublicAggreDealsV3Api.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicAggreDealsV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicAggreDealsV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicAggreDealsV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicAggreDealsV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
dealsList: jspb.Message.toObjectList(msg.getDealsList(),
    proto.PublicAggreDealsV3ApiItem.toObject, includeInstance),
eventtype: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicAggreDealsV3Api}
 */
proto.PublicAggreDealsV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicAggreDealsV3Api;
  return proto.PublicAggreDealsV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicAggreDealsV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicAggreDealsV3Api}
 */
proto.PublicAggreDealsV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.PublicAggreDealsV3ApiItem;
      reader.readMessage(value,proto.PublicAggreDealsV3ApiItem.deserializeBinaryFromReader);
      msg.addDeals(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEventtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicAggreDealsV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicAggreDealsV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicAggreDealsV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicAggreDealsV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDealsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.PublicAggreDealsV3ApiItem.serializeBinaryToWriter
    );
  }
  f = message.getEventtype();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated PublicAggreDealsV3ApiItem deals = 1;
 * @return {!Array<!proto.PublicAggreDealsV3ApiItem>}
 */
proto.PublicAggreDealsV3Api.prototype.getDealsList = function() {
  return /** @type{!Array<!proto.PublicAggreDealsV3ApiItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.PublicAggreDealsV3ApiItem, 1));
};


/**
 * @param {!Array<!proto.PublicAggreDealsV3ApiItem>} value
 * @return {!proto.PublicAggreDealsV3Api} returns this
*/
proto.PublicAggreDealsV3Api.prototype.setDealsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.PublicAggreDealsV3ApiItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PublicAggreDealsV3ApiItem}
 */
proto.PublicAggreDealsV3Api.prototype.addDeals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PublicAggreDealsV3ApiItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.PublicAggreDealsV3Api} returns this
 */
proto.PublicAggreDealsV3Api.prototype.clearDealsList = function() {
  return this.setDealsList([]);
};


/**
 * optional string eventType = 2;
 * @return {string}
 */
proto.PublicAggreDealsV3Api.prototype.getEventtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicAggreDealsV3Api} returns this
 */
proto.PublicAggreDealsV3Api.prototype.setEventtype = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicAggreDealsV3ApiItem.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicAggreDealsV3ApiItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicAggreDealsV3ApiItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicAggreDealsV3ApiItem.toObject = function(includeInstance, msg) {
  var f, obj = {
price: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, ""),
tradetype: jspb.Message.getFieldWithDefault(msg, 3, 0),
time: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicAggreDealsV3ApiItem}
 */
proto.PublicAggreDealsV3ApiItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicAggreDealsV3ApiItem;
  return proto.PublicAggreDealsV3ApiItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicAggreDealsV3ApiItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicAggreDealsV3ApiItem}
 */
proto.PublicAggreDealsV3ApiItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPrice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTradetype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicAggreDealsV3ApiItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicAggreDealsV3ApiItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicAggreDealsV3ApiItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicAggreDealsV3ApiItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradetype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string price = 1;
 * @return {string}
 */
proto.PublicAggreDealsV3ApiItem.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicAggreDealsV3ApiItem} returns this
 */
proto.PublicAggreDealsV3ApiItem.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string quantity = 2;
 * @return {string}
 */
proto.PublicAggreDealsV3ApiItem.prototype.getQuantity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicAggreDealsV3ApiItem} returns this
 */
proto.PublicAggreDealsV3ApiItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 tradeType = 3;
 * @return {number}
 */
proto.PublicAggreDealsV3ApiItem.prototype.getTradetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.PublicAggreDealsV3ApiItem} returns this
 */
proto.PublicAggreDealsV3ApiItem.prototype.setTradetype = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 time = 4;
 * @return {number}
 */
proto.PublicAggreDealsV3ApiItem.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.PublicAggreDealsV3ApiItem} returns this
 */
proto.PublicAggreDealsV3ApiItem.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto);
